import { effect, inject, signal } from "@angular/core";
import { StepStatusType } from "../../../../../models/order/order.model";
import { OrderStateServiceV2 } from "../order-state.service";

export abstract class BaseWorkflowStateService<T> {
    protected orderStateService = inject(OrderStateServiceV2)
    protected abstract stateKey: string;
    readonly state = signal<T | null>(null);

    /**
     *
     */
    constructor() {
        effect(() => {
            const order = this.orderStateService.order();
            if (!order) {
                this.state.set(null);
            }
        });

    }

    updateData(value: Partial<T>) {
        this.state.update(s => ({
            ...s,
            ...value,
            status: StepStatusType.InProgress,
            lastSavedAt: new Date().toISOString()
        }));
        this.saveLocalDraft();
    }

    overrideData(value: Partial<T>) {
        this.state.set({
            ...value,
            status: StepStatusType.InProgress,
            lastSavedAt: new Date().toISOString()
        } as T);
        this.saveLocalDraft();
    }

    /** Mark step complete and save it */
    async markStepComplete() {
        this.state.update(s => ({
            ...s,
            status: StepStatusType.Completed,
            lastSavedAt: new Date().toISOString()
        }));
        this.saveLocalDraft();
        await this.orderStateService.saveOrderData();
    }

    /** Hydrate from API Order object */
    loadFromOrder(orderSetup: T | undefined) {
        this.state.set(orderSetup ?? null);
    }

    /** Clear this slice of state */
    clear() {
        this.state.set(null);
        this.saveLocalDraft();
    }

    protected saveLocalDraft() {
        this.orderStateService.updateOrder({ [this.stateKey]: this.state() });
    }
}
